import script from "./NotificationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsPage.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsPage.vue?vue&type=style&index=0&id=4a6405b6&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a6405b6"]])

export default __exports__